import { useSelector } from 'react-redux';

export const getFeatureFlags = (state) => {
  const { features, hasRequestSucceeded: hasLoaded } = state.featureToggle;

  return {
    features,
    loading: !hasLoaded,
    refreshAvailabilityCalendarFlagIsEnabled: true,
    refreshSearchRevampFlagIsEnabled: true,
    infiniteLoadingFixFlagIsEnabled: true,
    sunsetMessageDisplayFlagIsEnabled: hasLoaded
      ? features.get('dining-sunset-message-display')
      : false,
    readOnlyModeFlagIsEnabled: hasLoaded
      ? !!features.get('dining-read-only-mode')
      : false,
  };
};

export const useFeatureFlags = () => {
  return useSelector(getFeatureFlags);
};
